export class Payers {
    constructor(http) {
      this.http = http;
    }


    fetchPayer(payer_id) {
      console.log('fetchPayer', payer_id);
      return this.http.get(`payer/${payer_id}/`).then(response => response.data);
    }
  
    fetchPayers(filter_by, page, search, page_size, startDate, endDate) {
      return this.http
        .post('payers/', { filter_by, page, search, page_size, startDate, endDate })
        .then(response => response);
    }
  
    fetchPayersFilter(filter_by, page, search, page_size, startDate, endDate) {
      return this.http
        .post('payers/', { filter_by, page, search, page_size, startDate, endDate })
        .then(response => response);
    }
  }
  